import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=5e2e8e57&scoped=true"
import script from "./Flight.vue?vue&type=script&lang=js"
export * from "./Flight.vue?vue&type=script&lang=js"
import style0 from "./Flight.vue?vue&type=style&index=0&id=5e2e8e57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2e8e57",
  null
  
)

export default component.exports